<script setup lang="ts">
import type {
	PropertyPhotoCarouselGridItemEmits,
	PropertyPhotoCarouselGridItemProps
} from '.';

const props = withDefaults(defineProps<PropertyPhotoCarouselGridItemProps>(), {
	isLoading: false,
	skeletonVariant: 'white',
	imageProps: () => ({
		preload: false,
		fetchpriority: 'auto',
		decoding: 'async'
	})
});

const emit = defineEmits<PropertyPhotoCarouselGridItemEmits>();

function handlePhotoClick(photoIndex: number, photoUrl: string) {
	emit('photo-clicked', photoIndex, photoUrl);
}
</script>

<template>
	<div class="grid h-full grid-cols-2 grid-rows-2 gap-0.5 bg-black">
		<div class="relative row-span-2 overflow-hidden">
			<Skeleton
				:is-active="isLoading"
				class="size-full"
				:variant="props.skeletonVariant"
			>
				<NuxtImg
					:src="photos[0]?.watermarkUrl"
					:alt="getImageAlt(startIndex)"
					width="480"
					sizes="lg:320px xl:400px 2xl:480px"
					densities="x1"
					:preload="imageProps.preload"
					:fetchpriority="imageProps.fetchpriority"
					:decoding="imageProps.decoding"
					:loading="startIndex === 0 ? 'eager' : 'lazy'"
					class="size-full cursor-pointer object-cover object-center"
					format="webp"
					quality="80"
					@click="handlePhotoClick(startIndex, photos[0]?.watermarkUrl || '')"
				/>
			</Skeleton>
		</div>

		<div class="relative overflow-hidden">
			<Skeleton
				:is-active="isLoading"
				class="size-full"
				:variant="props.skeletonVariant"
			>
				<NuxtImg
					:src="photos[1]?.watermarkUrl"
					:alt="getImageAlt(startIndex + 1)"
					width="480"
					sizes="lg:320px xl:400px 2xl:480px"
					densities="x1"
					:preload="imageProps.preload"
					:fetchpriority="imageProps.fetchpriority"
					:decoding="imageProps.decoding"
					loading="lazy"
					class="size-full cursor-pointer object-cover object-center"
					format="webp"
					quality="80"
					@click="
						handlePhotoClick(startIndex + 1, photos[1]?.watermarkUrl || '')
					"
				/>
			</Skeleton>
		</div>

		<div class="relative overflow-hidden">
			<Skeleton
				:is-active="isLoading"
				class="size-full"
				:variant="props.skeletonVariant"
			>
				<NuxtImg
					:src="photos[2]?.watermarkUrl"
					:alt="getImageAlt(startIndex + 2)"
					width="480"
					sizes="lg:320px xl:400px 2xl:480px"
					densities="x1"
					:preload="imageProps.preload"
					:fetchpriority="imageProps.fetchpriority"
					:decoding="imageProps.decoding"
					loading="lazy"
					class="size-full cursor-pointer object-cover object-center"
					format="webp"
					quality="80"
					@click="
						handlePhotoClick(startIndex + 2, photos[2]?.watermarkUrl || '')
					"
				/>
			</Skeleton>
		</div>
	</div>
</template>
